var SharedModule = /** @class */ /*@__PURE__*/ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
